import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchCallHistoryNumber = createAsyncThunk(
  "callHistoryNumber/fetchCallHistoryNumber",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/call/phone-number-call-history",
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
const initialState = {
  loading: false,
  data: [],
  summary: {},
  pagination: {
    page: 1,
    page_size: 10,
    total: 0,
  },
  error: null,
};

const CallHistoryNumberSlice = createSlice({
  name: "callHistoryNumber",
  initialState,
  reducers: {
    clearCallHistoryNumber: (state) => {

      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallHistoryNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallHistoryNumber.fulfilled, (state, action) => {
        state.loading = false;

        state.data = action.payload.callRecords || [];

        state.summary = action.payload.summary || {};

        state.pagination = {
          page: action.payload.page || 1,
          page_size: action.payload.page_size || 10,
          total: action.payload.totalRecords || 0,
        };

        state.error = null;
      })
      .addCase(fetchCallHistoryNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearCallHistoryNumber } = CallHistoryNumberSlice.actions;

export default CallHistoryNumberSlice.reducer;
